<template>
  <b-card-body>
    <b-card class="chart-meta-config-container">
      <b-form>
        <!-- Categoria de dados -->
        <b-form-group label="Selecione as configurações do gráfico:">
          <div
            class="radio-option mt-2"
            v-for="opt in options"
            :key="opt.value">
            <label class="cursor">
              <input type="radio"
                     v-model="localConfig.selectedCategory"
                     :value="opt.value"/>
              <span>{{ opt.label }}</span>
            </label>
          </div>
        </b-form-group>

        <!-- Tipo de Ocorrência (só para ocorrenciasTotais) -->
        <b-form-group v-if="localConfig.selectedCategory === 'ocorrenciasTotais'"
                      label="Tipo de Ocorrência:"
                      class="mt-2">
          <div class="radio-option mt-2"
               v-for="opt in ocorrenciasTipoOptions"
               :key="opt.value">
            <label class="cursor">
              <input type="radio"
                     v-model="localConfig.ocorrenciasTipo"
                     :value="opt.value"/>
              <span>{{ opt.label }}</span>
            </label>
          </div>
        </b-form-group>

        <!-- Seleção de Tela -->
        <b-form-group v-if="requiresTela" label="Tela:">
          <b-form-select class="custom-select-color"
                         v-model="localConfig.selectedTela"
                         :options="listaTelas"
                         @change="onTelaChange"/>
        </b-form-group>

        <!-- Seleção de Área -->
        <b-form-group v-if="requiresArea" label="Área:" class="mt-2">
          <b-form-select class="custom-select-color"
                         v-model="localConfig.selectedArea"
                         :options="listaAreas"/>
        </b-form-group>

        <!-- Orientação -->
        <b-form-group class="mt-4" label="Tipo de Gráfico:">
          <div class="radio-option mt-2"
               v-for="opt in orientationOptions"
               :key="opt.value">
            <label class="cursor">
              <input type="radio"
                     v-model="localConfig.orientation"
                     :value="opt.value"/>
              <span>{{ opt.label }}</span>
            </label>
          </div>
        </b-form-group>

        <!-- Meta Range Inicial -->
        <b-form-group v-if="showMetaFields && localConfig.selectedCategory != 'ocorrenciasTotais'"
                      class="mt-2"
                      label="Meta Range Inicial (%):">
          <b-form-input type="number"
                        v-model.number="localConfig.rangeStart"
                        placeholder="Ex: 80"
                        min="0"/>
        </b-form-group>

        <!-- Meta Range Final -->
        <b-form-group v-if="showMetaFields && localConfig.selectedCategory != 'ocorrenciasTotais'"
                      class="mt-2"
                      label="Meta Range Final (%):">
          <b-form-input type="number"
                        v-model.number="localConfig.rangeEnd"
                        :min="localConfig.rangeStart"
                        placeholder="Ex: 90"/>
        </b-form-group>

        <!-- Botões -->
        <div class="modal-buttons text-right">
          <img class="action-btn"
               src="@/assets/salvar.png"
               width="30" height="30"
               @click="onSave"/>
          <img class="action-btn ml-3 exit-btn"
               src="@/assets/sair.png"
               width="30" height="30"
               @click="$emit('close')"/>
        </div>
      </b-form>
    </b-card>
  </b-card-body>
</template>

<script>
export default {
  name: 'ChartBarConfigModal',
  props: {
    config: {
      type: Object,
      default: () => ({
        selectedCategory: 'geral',
        selectedTela:     '',
        selectedArea:     '',
        orientation:      'barras',
        rangeStart:       0,
        rangeEnd:         0,
        ocorrenciasTipo:  'abertas'
      })
    },
    screensAreas: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data() {
    return {
      localConfig: {
        selectedCategory: this.config.selectedCategory,
        selectedTela:     this.config.selectedTela,
        selectedArea:     this.config.selectedArea,
        orientation:      this.config.orientation,
        rangeStart:       this.config.rangeStart ?? 0,
        rangeEnd:         this.config.rangeEnd   ?? 0,
        ocorrenciasTipo:  this.config.ocorrenciasTipo ?? 'abertas'
      },
      listaAreas: [],
      options: [
        { value: 'geral',               label: 'Aderência geral dos indicadores' },
        { value: 'ocorrenciasTotais',   label: 'Ocorrências Totais por Turno' },
        { value: 'fechamentoGeral',     label: 'Ocorrências Tratadas (%) por Turno (Geral)' },
        { value: 'ocorrenciasTratadas', label: 'Ocorrências Tratadas (%) por Área' },
        { value: 'porTela',             label: 'Aderência dos Indicadores por Tela' },
        { value: 'porArea',             label: 'Aderência dos Indicadores por Área' },
      ],
      ocorrenciasTipoOptions: [
        { value: 'abertas',  label: 'Abertas' },
        { value: 'fechadas', label: 'Fechadas' }
      ],
      orientationOptions: [
        { value: 'barras',         label: 'Barras Verticais' },
        { value: 'barrasDeitadas', label: 'Barras Horizontais' }
      ]
    };
  },
  computed: {
    listaTelas() {
      const keys = Object.keys(this.screensAreas || {});
      const telas = keys.map(k => ({ value: k, text: k }));
      return [{ value: '', text: 'Selecione a Tela' }, ...telas];
    },
    requiresTela() {
      return [
        'geral',
        'porTela',
        'porArea',
        'ocorrenciasTotais',
        'ocorrenciasTratadas',
        'fechamentoGeral'
      ].includes(this.localConfig.selectedCategory);
    },
    requiresArea() {
      return this.localConfig.selectedCategory === 'porArea';
    },
    /* ← mostra meta só se NÃO estiver em ocorrenciasTotais */
    showMetaFields() {
      return this.localConfig.selectedCategory !== 'ocorrenciasTotais';
    }
  },
  watch: {
    config: {
      immediate: true,
      handler(newVal) {
        this.localConfig = {
          selectedCategory: newVal.selectedCategory,
          selectedTela:     newVal.selectedTela,
          selectedArea:     newVal.selectedArea,
          orientation:      newVal.orientation,
          rangeStart:       newVal.rangeStart ?? 0,
          rangeEnd:         newVal.rangeEnd   ?? 0,
          ocorrenciasTipo:  newVal.ocorrenciasTipo ?? 'abertas'
        };
        if (this.requiresArea && this.localConfig.selectedTela) this.fetchAreas();
      }
    },
    'localConfig.selectedCategory'(val) {
      this.localConfig.selectedTela = '';
      this.localConfig.selectedArea = '';
      this.listaAreas = [];

      /* limpa metas quando entra em ocorrenciasTotais */
      if (val === 'ocorrenciasTotais') {
        this.localConfig.rangeStart = 0;
        this.localConfig.rangeEnd   = 0;
      }
    },
    'localConfig.selectedTela'() {
      if (this.requiresArea) this.fetchAreas();
    }
  },
  methods: {
    fetchAreas() {
      const tela = this.localConfig.selectedTela;
      if (tela && this.screensAreas[tela]) {
        this.listaAreas = [
          { value: '', text: 'Selecione a Área' },
          ...this.screensAreas[tela].map(a => ({ value: a, text: a }))
        ];
      } else {
        this.listaAreas = [{ value: '', text: 'Selecione a Área' }];
      }
    },
    onTelaChange() {
      this.fetchAreas();
      this.localConfig.selectedArea = '';
    },
    showWarn(msg) {
      this.$bvToast.toast(msg, {
        title: 'Atenção',
        variant: 'warning',
        toaster: 'b-toaster-bottom-left',
        solid: true
      });
    },
    onSave() {
      if (this.requiresTela && !this.localConfig.selectedTela) {
        this.showWarn('Selecione uma Tela antes de salvar.');
        return;
      }
      if (this.requiresArea && !this.localConfig.selectedArea) {
        this.showWarn('Selecione uma Área antes de salvar.');
        return;
      }
      this.$emit('save', { ...this.localConfig });
    }
  }
};
</script>

<style scoped>
.radio-option {
  display: flex;
  align-items: center;
}

.radio-option input[type='radio'] {
  accent-color: #009a9a;
  margin-right: 10px;
}

.chart-meta-config-container {
  padding: 10px;
}

.custom-select-color {
  border: 1px solid #ff751b !important;
  border-radius: 4px;
  padding: 5px;
  font-size: 16px;
}

.custom-select-color:focus {
  border-color: #ff751b !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 117, 27, 0.25) !important;
}

.modal-buttons {
  margin-top: 20px;
}

.action-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}

.exit-btn {
  margin-left: 14px;
}

.cursor {
  cursor: pointer;
  margin-left: 5px;
}

.form-group {
  margin-bottom: 0;
}
</style>

